import { Component, OnInit } from "@angular/core";
import { NewPageService } from "../../templates/new-page/service/new-page.service";
import { NewPageList } from "../../core/models/new-page-list";
import { ConfirmationService } from "primeng/components/common/confirmationservice";
import { Constants } from "../../core/config/Constants";

@Component({
  selector: "app-url-box",
  templateUrl: "./url-box.component.html",
  styleUrls: ["./url-box.component.css"],
  providers: [NewPageService]
})
export class UrlBoxComponent implements OnInit {
  constructor(
    private newPageService: NewPageService,
    private confirmationService: ConfirmationService
  ) {
    this.newPageService.validate$.subscribe(validate => {
      if (validate) {
        this.validate();
      }
    });
  }

  urlClass = "form-control";
  aboutUs: NewPageList;
  eventURL: boolean = true;

  ngOnInit() {
    if (this.aboutUs.aboutPrefs.urlstyle === undefined) {
      this.aboutUs.aboutPrefs.urlstyle =
        Constants.ABOUT_TYPE_URL_PREF_STYLE_URL;
    }
    console.log(this.aboutUs);
  }

  _ref: any;

  confirmDelete() {
    this.confirmationService.confirm({
      message: "Are you sure that you want to delete ?",
      accept: () => {
        this.remove();
      }
    });
  }

  remove() {
    this.newPageService.removeItem(this.aboutUs);
    this._ref.destroy();
  }

  upItem() {
    this.newPageService.upItem(this.aboutUs);
  }

  downItem() {
    this.newPageService.downItem(this.aboutUs);
  }

  validate() {
    if (this.aboutUs.url == null || this.aboutUs.url.trim().length < 1) {
      this.urlClass = "form-control fieldWithErrors";
    } else {
      this.urlClass = "form-control";
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/layout/url-box/url-box.component.ts